import React from 'react';
import Datetime from 'react-datetime';

const DateTime = (props) => {
  return (
    <Datetime {...props} />
  );
};

export default DateTime;
